module.exports = __webpack_public_path__ + "img/psm_logo-inverse.7943250f.png";